import { render, staticRenderFns } from "./StudentStaff.vue?vue&type=template&id=2f073992"
import script from "./StudentStaff.vue?vue&type=script&lang=js"
export * from "./StudentStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports